import { OGDB_CACHE_TAG } from './cacheTag';
import type { FoodRef } from './types';

const REVALIDATE_SECONDS = 3600;

export async function post(
  url: string,
  timeoutMs: number,
  init: RequestInit = {},
): Promise<{ status: number; body: unknown }> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(url, {
      method: 'POST',
      signal: controller.signal,
      next: { revalidate: REVALIDATE_SECONDS, tags: [OGDB_CACHE_TAG] },
      ...init,
    });
    const text = await res.text();
    let body: unknown = null;
    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      // HTML error page: status alone decides
    }
    return { status: res.status, body };
  } finally {
    clearTimeout(timer);
  }
}

export const refUrl = (base: string, ref: FoodRef) => {
  const url = new URL(base);
  if ('foodId' in ref) url.searchParams.set('food_id', ref.foodId);
  else url.searchParams.set('url_friendly_name', ref.urlFriendlyName);
  return url.href;
};
